export const updateAudit = {
  schemaVersion: "1.0.0",
  auditedAt: "2026-07-29",
  registryVersion: "2026.07.29.1",
  releaseNotes: [
    {
      type: "self-hosted-expression-and-submission-backend",
      affectedRecords: ["brg-2021-bsf", "brg-2023-replicative"],
      summary:
        "Retired runtime author-expression proxies. Briggs 2021 and 2023 now use integrity-checked, versioned same-origin conversions of CC BY 4.0 author deposits; T. cruzi expression remains withheld pending redistribution review. Added an account-free EdgeOne submission queue with private token-protected review.",
      summaryZh:
        "停用运行时作者表达代理。Briggs 2021与2023现使用经完整性校验、版本化且同域分发的CC BY 4.0作者存档转换；T. cruzi表达层在再发布审核完成前继续不提供。新增免账户EdgeOne提交队列与令牌保护的私有审核。",
      evidence: "https://zenodo.org/records/5163554",
    },
    {
      type: "scientific-correction-laidlaw-strain",
      affectedRecords: ["lai-2026-cruzi"],
      summary:
        "Laidlaw et al. 2026 biological strain corrected to Silvio X10/7 A1; Dm28c 2018 retained only as the mapping reference.",
      summaryZh:
        "Laidlaw等（2026）的实验株纠正为Silvio X10/7 A1；Dm28c 2018仅作为比对参考保留。",
      evidence: "https://www.nature.com/articles/s41467-026-73098-w",
    },
    {
      type: "scientific-correction-briggs-2021-scope",
      affectedRecords: ["brg-2021-bsf"],
      summary:
        "Briggs et al. 2021 now uses the paper spelling EATRO 1125 AnTa1.1 90:13 and states that 10,894 cells comprise 8,599 WT plus 2,295 ZC3H20-KO cells.",
      summaryZh:
        "Briggs等（2021）现采用论文拼写EATRO 1125 AnTa1.1 90:13，并明确10,894个细胞由8,599个野生型与2,295个ZC3H20敲除细胞构成。",
      evidence: "https://www.nature.com/articles/s41467-021-25607-2",
    },
    {
      type: "scientific-correction-howick-strain-boundary",
      affectedRecords: ["how-2022-tsetse"],
      summary:
        "Howick et al. 2022 now records the exact J10 and 1738 strain identifiers, treats DP as a FACS sorting group and exposes the stage–strain confounding and VSG-reference limitation.",
      summaryZh:
        "Howick等（2022）现记录J10与1738的完整菌株编号，将DP明确为FACS分选组，并公开阶段—菌株混杂及VSG参考偏差限制。",
      evidence:
        "https://journals.plos.org/plospathogens/article?id=10.1371/journal.ppat.1010346",
    },
    {
      type: "scientific-correction-reuter-citation-method",
      affectedRecords: ["reu-2023-skin"],
      summary:
        "Reuter et al. 2023 citation corrected to Nature Communications 14, article 7660; the Methods SMART-Seq v4 wording and Figure 4 Smart-seq2/Nextera wording are both preserved.",
      summaryZh:
        "Reuter等（2023）的引文纠正为Nature Communications第14卷、文章7660；同时保留Methods中的SMART-Seq v4与Figure 4图注中的Smart-seq2/Nextera两种来源表述。",
      evidence: "https://www.nature.com/articles/s41467-023-43437-2",
    },
    {
      type: "scientific-correction-inchausti-count-source",
      affectedRecords: ["inc-2026-cruzi"],
      summary:
        "Inchausti et al. 2026 catalogue count corrected to 3,151 final singlets after removal of 41 doublets from 3,192 post-QC cells; infected H9c2 experimental source is kept separate from the SRA isolation-source field.",
      summaryZh:
        "Inchausti等（2026）的目录细胞数纠正为3,151个最终singlet（3,192个质控后细胞移除41个双细胞）；感染H9c2的实验来源与SRA isolation-source字段分开记录。",
      evidence: "https://elifesciences.org/articles/105822",
    },
    {
      type: "metadata",
      summary:
        "Added study-level data passports, controlled availability and curation status, expression semantics, coordinate status and explicit licence boundaries.",
      summaryZh:
        "新增逐研究数据护照、受控可用性与审核状态、表达语义、坐标状态及明确许可边界。",
    },
    {
      type: "interoperability",
      summary:
        "Added JSON and CSV registry exports, Schema.org Dataset markup, a public JSON Schema, robots.txt and sitemap.xml.",
      summaryZh:
        "新增JSON/CSV注册表、Schema.org Dataset标记、公开JSON Schema、robots.txt与sitemap.xml。",
    },
  ],
  policy: {
    cadence:
      "Repository metadata: monthly; primary-paper and author-processed archives: quarterly; new-study discovery: monthly.",
    publication:
      "A changed source creates a review item. It never updates public cell totals, labels or expression layers until a scientific reviewer approves the evidence and a versioned release is published.",
    failure:
      "An unreachable source is marked for review. Existing verified data remain available with their last successful audit date; no replacement values are generated.",
  },
  automation: {
    discoveryRegistry: "implemented",
    onDemandConnectivityChecker: "implemented",
    machineReadableStatus: "implemented",
    authenticatedReviewSurface: "implemented",
    scheduledRunner: "monthly-codex-evidence-audit-active",
    explanation:
      "A monthly project-scoped evidence audit checks registered endpoints and searches primary repositories. It reports evidence for human review and is deliberately prohibited from editing scientific data or deploying releases.",
  },
  roles: [
    {
      id: "administrator",
      name: "Administrator",
      nameZh: "管理员",
      permissions: [
        "Manage reviewer membership",
        "Approve releases",
        "Publish or retract portal records",
      ],
    },
    {
      id: "scientific-reviewer",
      name: "Scientific reviewer",
      nameZh: "科学审核员",
      permissions: [
        "Verify paper and repository claims",
        "Approve terminology mappings",
        "Record unresolved discrepancies",
      ],
    },
    {
      id: "submitter",
      name: "Data submitter",
      nameZh: "数据提交者",
      permissions: [
        "Propose a study",
        "Provide verifiable source links",
        "Respond to reviewer questions",
      ],
    },
  ],
  workflow: [
    "discovered",
    "metadata-verified",
    "scientific-review",
    "approved",
    "published",
  ],
  sources: [
    {
      id: "prjeb41744",
      label: "Briggs et al. 2021",
      paper: "https://doi.org/10.1038/s41467-021-25607-2",
      repository: "https://www.ebi.ac.uk/ena/browser/view/PRJEB41744",
      processed: "https://zenodo.org/records/5163554",
      lastChecked: "2026-07-27",
      status: "verified",
      nextReview: "2026-08-27",
      publicRecord: "/datasets/prjeb41744/",
    },
    {
      id: "erp132258",
      label: "Howick et al. 2022",
      paper: "https://doi.org/10.1371/journal.ppat.1010346",
      repository: "https://www.ebi.ac.uk/ena/browser/view/ERP132258",
      processed: "https://zenodo.org/records/6047732",
      lastChecked: "2026-07-27",
      status: "verified-with-boundary",
      nextReview: "2026-08-27",
      publicRecord: "/datasets/erp132258/",
    },
    {
      id: "prjeb58781",
      label: "Briggs et al. 2023",
      paper: "https://doi.org/10.7554/eLife.86325",
      repository: "https://www.ebi.ac.uk/ena/browser/view/PRJEB58781",
      processed: "https://zenodo.org/records/7508131",
      lastChecked: "2026-07-27",
      status: "verified",
      nextReview: "2026-08-27",
      publicRecord: "/datasets/prjeb58781/",
    },
    {
      id: "gse174198",
      label: "Reuter et al. 2023",
      paper: "https://doi.org/10.1038/s41467-023-43437-2",
      repository:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE174198",
      processed:
        "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE174198",
      lastChecked: "2026-07-27",
      status: "verified-with-embedding-boundary",
      nextReview: "2026-08-27",
      publicRecord: "/datasets/gse174198/",
    },
    {
      id: "e-mtab-14406",
      label: "Laidlaw et al. 2026",
      paper: "https://doi.org/10.1038/s41467-026-73098-w",
      repository:
        "https://www.ebi.ac.uk/biostudies/arrayexpress/studies/E-MTAB-14406",
      processed:
        "https://cellatlas-cxg.mvls.gla.ac.uk/view/Trypanosoma_cruzi_inVitro_cellatlas.h5ad/",
      lastChecked: "2026-07-27",
      status: "verified-with-boundary",
      nextReview: "2026-08-27",
      publicRecord: "/datasets/e-mtab-14406/",
    },
    {
      id: "prjna1200704",
      label: "Inchausti et al. 2026",
      paper: "https://doi.org/10.7554/eLife.105822",
      repository: "https://www.ncbi.nlm.nih.gov/bioproject/PRJNA1200704",
      processed: "https://zenodo.org/records/18760090",
      lastChecked: "2026-07-27",
      status: "verified-with-boundary",
      nextReview: "2026-08-27",
      publicRecord: "/datasets/prjna1200704/",
    },
  ],
  reviewQueue: [
    {
      id: "GSE174198-AUTHOR-CODE",
      source: "Reuter et al. 2023",
      state: "scientific-review",
      priority: "medium",
      issue:
        "The paper states that code is on GitHub, but no repository URL is exposed on the official article pages.",
      issueZh:
        "论文说明分析代码位于 GitHub，但官方文章页面没有给出可核验的仓库地址。",
      safePublicAction:
        "Keep the code link unavailable and do not present a recomputed PCA as author coordinates.",
      safePublicActionZh:
        "代码链接继续标记为不可用，不把重新计算的 PCA 冒充作者坐标。",
      evidence: [
        {
          label: "Primary paper",
          url: "https://doi.org/10.1038/s41467-023-43437-2",
        },
      ],
    },
    {
      id: "PRJNA1200704-FINAL-OBJECT",
      source: "Inchausti et al. 2026",
      state: "scientific-review",
      priority: "medium",
      issue:
        "Final author cell metadata and embedding coordinates are not deposited with the current public release.",
      issueZh:
        "当前公开版本没有存放作者最终细胞元数据和降维坐标。",
      safePublicAction:
        "Keep the study in the catalogue without fabricating a final interactive atlas.",
      safePublicActionZh:
        "保留该研究的目录记录，但不编造最终交互图谱。",
      evidence: [
        {
          label: "Primary paper",
          url: "https://doi.org/10.7554/eLife.105822",
        },
        {
          label: "BioProject",
          url: "https://www.ncbi.nlm.nih.gov/bioproject/PRJNA1200704",
        },
      ],
    },
    {
      id: "PRJEB72370-CANDIDATE-CURATION",
      source: "Keneskhanova et al. 2025",
      state: "scientific-review",
      priority: "high",
      issue:
        "A qualifying T. brucei single-cell study using SL-Smart-seq3xpress and public ENA accession PRJEB72370 was identified during the 2026-07-27 discovery audit. Its cell, sample, matrix, licence and annotation boundaries have not yet completed portal curation.",
      issueZh:
        "2026-07-27 新研究检索发现了一项符合范围的布氏锥虫单细胞研究，使用 SL-Smart-seq3xpress，公共 ENA 登录号为 PRJEB72370；其细胞、样本、矩阵、许可和注释边界尚未完成本站审核。",
      safePublicAction:
        "Expose it only as a candidate evidence item. Do not add it to catalogue totals or atlas layers until scientific curation is complete.",
      safePublicActionZh:
        "目前仅作为候选证据公开；完成科学审核前，不计入正式目录总数，也不加入图谱表达层。",
      evidence: [
        {
          label: "Primary paper",
          url: "https://doi.org/10.1038/s41586-025-08720-w",
        },
        {
          label: "ENA PRJEB72370",
          url: "https://www.ebi.ac.uk/ena/browser/view/PRJEB72370",
        },
      ],
    },
  ],
} as const;
